module.exports = __webpack_public_path__ + "img/bg_age_3.155bbc32.png";